export const FROM_NOTIFICATIONS = 'FROM_NOTIFICATIONS';
export const JUST_CREATED = 'JUST_CREATED';
